/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForMetricData extends models.GovernanceConfigurationBaseForOperations {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForMetricData");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForMetricData.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForMetricData>): GovernanceConfigurationForMetricData {
        let obj = Object.assign(new GovernanceConfigurationForMetricData(), model);
        GovernanceConfigurationForMetricData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForMetricData>): GovernanceConfigurationForMetricData {
        if (!model) return null;
        return GovernanceConfigurationForMetricData.newInstance(<GovernanceConfigurationForMetricData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForMetricData) {
        if (!obj) return;

        models.GovernanceConfigurationForMetricData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForMetricData): boolean {
        if (models.GovernanceConfigurationBaseForOperations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForMetricData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.refresh_interval === undefined) {
            this.refresh_interval = 0;
        }
    }

    /**
     * Metric Data Refresh Interval
     */
    refresh_interval: number;

}
